import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { withRouter } from 'react-router-dom';
import createGroupItem from './GroupsSearchItem';

/**
 * hoc для автоматизации управления универсальным reducer list и состоянием location search
 * - при изменении в store подготовленных параметров к отправке запроса, компонент вызывает запрос
 * - при изменении location search компонент меняет параметры запроса в store и вызывает запрос
 * */
export default function createGroup(WrappedComponents) {
  class GroupsSearchCollector extends Component {
    constructor(props) {
      super(props);
      this.groupQueryParams = qs.parse(this.props.location.search.slice(1));
      this.components = Object.keys(WrappedComponents).map(objectKey => {
        const ComponentItem = createGroupItem(
          WrappedComponents[objectKey].component,
          objectKey
        );
        return () => (
          <ComponentItem
            {...this.props}
            {...WrappedComponents[objectKey].props}
            key={`groupsSearchCollector-${objectKey}`}
            groupName={objectKey}
            listReduceName={WrappedComponents[objectKey].listReduceName}
            setGroupQueryParamsAndUpdateHistory={
              this.setGroupQueryParamsAndUpdateHistory
            }
          />
        );
      });
    }

    setGroupQueryParamsAndUpdateHistory = queryParams => {
      this.groupQueryParams = {
        ...this.groupQueryParams,
        ...queryParams
      };
      this.context.router.history.push({
        pathname: this.props.location.pathname,
        search: `?${qs.stringify(this.groupQueryParams)}`
      });
    };

    render() {
      return (
        <React.Fragment>
          {this.components.map(ComponentItem => (
            <ComponentItem {...this.props} />
          ))}
        </React.Fragment>
      );
    }
  }
  GroupsSearchCollector.displayName = `GroupsSearchCollector`;
  GroupsSearchCollector.propTypes = {
    location: PropTypes.shape({
      search: PropTypes.string.isRequired,
      pathname: PropTypes.string.isRequired
    }).isRequired
  };
  GroupsSearchCollector.contextTypes = {
    router: PropTypes.shape()
  };
  return withRouter(GroupsSearchCollector);
}



// WEBPACK FOOTER //
// ./src/components/Hocs/GroupsSearchCollector/GroupsSearchCollector.js